import { getOrganizationForm } from './../models/organization-form.model';
import {
  ContactInfoComponent, getContactFormGroup
} from '../../../widgets/entry-components/modal/components/contact-info/contact-info.component';
import {
  TelecomAddComponent, getTelecomFormGroup
} from '../../../widgets/entry-components/modal/components/telecom-add/telecom-add.component';
import { ModalService } from '../../../widgets/entry-components/modal/services/modal.service';
import { Component } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { AddressComponent, getAddressFormGroup } from '../../../widgets/entry-components/modal/components/address/address.component';
import { TranslatePipe } from '../../../shared/translate/pipes/translate.pipe';
import { IOrganization } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractAddWmodalComponent } from '../../../shared/abstracts/add/abstract-add-wmodal/abstract-add-wmodal.component';
import { AssociativeArray } from '../../../user/login/shared/ass-array.model';

@Component({
  selector: 'inc-organization-add',
  templateUrl: './organization-add.component.html',
  styleUrls: ['./organization-add.component.scss'],
})
export class OrganizationAddComponent extends AbstractAddWmodalComponent<IOrganization> {
  modalComponents: AssociativeArray = {
    address: () => AddressComponent,
    telecom: () => TelecomAddComponent,
    contact: () => ContactInfoComponent
  };

  constructor(
    modalService: ModalService, actionSheetController: ActionSheetController,
    translatePipe: TranslatePipe) {
    super(modalService, actionSheetController, translatePipe);
  }

  pushInto() {
    this.pushIntoFormArray(this.inData, 'address', getAddressFormGroup);
    this.pushIntoFormArray(this.inData, 'telecom', getTelecomFormGroup);
    this.pushIntoFormArray(this.inData, 'contact', getContactFormGroup);
  }

  resetForm(): FormGroup {
    if (this.form) {
      return this.form;
    }
    return getOrganizationForm();
  }
}
